import { InvestProject } from '../invest-project';
import { InvestProjectYearSic } from './invest-project-year-sic';

export class InvestProjectSic extends InvestProject {
    years: InvestProjectYearSic[];

    constructor(name: string, year?: number) {
        super(name);

        this.years = [new InvestProjectYearSic(year || null)];
    }
}
